var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 108C33.5325 108 12 86.4675 12 60C12 33.5325 33.5325 12 60 12C86.4675 12 108 33.5325 108 60C108 86.4675 86.4675 108 60 108ZM63 101.895C84.7625 100.35 102 82.15 102 60C102 37.85 84.7625 19.65 63 18.105V101.895ZM41.6525 97.7775C46.3475 100.067 51.5325 101.505 57 101.895V71.1975L41.6525 97.7775ZM25.23 83.5375C28.2275 87.9525 32.045 91.77 36.46 94.7675L51.8025 68.195L25.23 83.5375ZM18.105 63C18.4925 68.4675 19.9325 73.6525 22.2225 78.3475L48.8025 63H18.105ZM18.105 57H48.8025L22.2225 41.6525C19.9325 46.3475 18.495 51.53 18.105 57ZM25.23 36.4625L51.8025 51.805L36.46 25.2325C32.045 28.23 28.2275 32.0475 25.23 36.4625ZM41.6525 22.2225L57 48.8025V18.105C51.5325 18.4925 46.3475 19.9325 41.6525 22.2225Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow);
export default __webpack_public_path__ + "static/media/Shadow.cc9f6c0a.svg";
export { ForwardRef as ReactComponent };